/*=========================================================================================
  File Name: module-notification-actions.js
  Description: Notification Module Actions
  ----------------------------------------------------------------------------------------
  Project: MISA MTAX WebApp
  Author: MISA JSC
  Author URL: http://www.misa.com.vn
==========================================================================================*/
import NotificationAPI from '@/api/NotificationAPI.js';
import httpClient from '../../api/axios-httpclient';
import PayFileAPI from '@/api/PayFileAPI.js';
import DecFileAPI from '@/api/DecFileAPI.js';
import { MSEnum } from '@/common/enumeration';

export default {
	loadNotification: async function(context, payload) {
		//Gán cờ loading
		context.commit('updateNotificationLoaded', false);

		//Gọi dữ liệu
		let res = await httpClient.postAsync({
			url: NotificationAPI.getAPIUrl() + '/paging',
			data: payload
		});

		//Thành công cập nhật dữ liệu
		if (res.Success) {
			context.commit('updateNotificationList', res);
		}

		//Gán cờ loading
		context.commit('updateNotificationLoaded', true);

		// Trả kết quả
		return res.Data;
	},

	countNotificationIsNew: async function(context, payload) {
		//Gọi dữ liệu
		let res = await httpClient.getAsync({
			url: NotificationAPI.getAPIUrl() + '/isnew'
		});

		//Thành công cập nhật dữ liệu
		if (res.Success) {
			context.commit('updateIsNewCount', res.Data);
		}
	},

	previewNotification: async function(context, payload) {
		//Gọi dữ liệu
		let res = await httpClient.postAsync({
			url: NotificationAPI.getAPIUrl() + '/previewnotification',
			data: payload
		});

		//Thành công xử lý dữ liệu
		if (res.Success && res.Data) {
			let url = '';
			if (payload.TypeServiceTvan == MSEnum.TaxType.TaxPay) {
				url =
					PayFileAPI.getAPIUrl() + '/getnotification?key=' + res.Data;
			} else {
				url =
					DecFileAPI.getAPIUrl() + '/getnotification?key=' + res.Data;
			}

			return url;
		} else {
			return null;
		}
	},

	updateNotificationIsNotNew: async function(context, payload) {
		//Gọi dữ liệu
		let res = await httpClient.getAsync({
			url: NotificationAPI.getAPIUrl() + '/isnotnew',
			params: payload
		});

		//Thành công xử lý
		if (res.Success) {
			context.commit('updateIsNewCount', 0);
		}

		return res;
	},

	getNotificationBySubmissionId: async function(context, payload) {
		//Gọi dữ liệu
		let res = await httpClient.getAsync(
			{
				url:
					NotificationAPI.getAPIUrl() +
					'/getnotificationbysubmissionid',
				params: payload
			},
			true
		);

		if (res.Success) {
			return res.Data;
		} else {
			return null;
		}
	},

	// Gọi màn hình preivew pdf
	previewpdfnotification: async function(context, payload) {
		//Gọi dữ liệu
		let res = await httpClient.getAsync(
			{
				url: NotificationAPI.getAPIUrl() + '/previewpdfnotification',
				params: payload
			},
			true
		);
		if (res) {
			return res;
		} else {
			return null;
		}
	},

	/**
	 * Lay JWT token de xac thuc voi MISA Notification In-App v2.
	 * Token co han 8 gio, cached trong store voi expiry 7 gio.
	 */
	getMisaNotificationV2Token: async function(context, payload) {
		const res = await httpClient.getAsync(
			{ url: NotificationAPI.getAPIUrl() + '/token-noti-v2' },
			false
		);

		if (res && res.Data) {
			return res.Data;
		}

		return null;
	}
};
